module.exports = __webpack_public_path__ + "img/crusher.78ddfbee.png";